// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { FaStar, FaTimes } from "react-icons/fa";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import Api from "../Utills/Api";
// import { toast } from "react-toastify";
// import axios from "axios";
// import logo from "../../Frozenwala.png";
// import { useWishlist } from "../../contexts/WishlistContext";
// import "./ProductModal.css";

// const ProductModal = ({ isOpen, productId, onClose, refreshCart }) => {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const [itemMedia, setItemMedia] = useState([]);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [comment, setComment] = useState("");
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [reviews, setReviews] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalReviews, setTotalReviews] = useState(0);
//   const [loadingReviews, setLoadingReviews] = useState(false);
//   const [submittingReview, setSubmittingReview] = useState(false);

//   const uid = localStorage.getItem("user_id");
//   const pageSize = 5;

//   useEffect(() => {
//     if (isOpen && productId) {
//       fetchProduct();
//     }
//   }, [isOpen, productId]);

//   useEffect(() => {
//     if (isOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [isOpen]);

//   // Handle escape key
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === 'Escape') onClose();
//     };
//     window.addEventListener('keydown', handleEsc);
//     return () => window.removeEventListener('keydown', handleEsc);
//   }, [onClose]);

//   const fetchProduct = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await fetch(
//         `https://backend.frozenwala.com/api/product-detail/?product_id=${productId}`
//       );
//       if (!response.ok) {
//         throw new Error("Failed to fetch product");
//       }
//       const data = await response.json();
//       setProduct(data.product);

//       const itemMediaFiles = [{ "media_path": data.product.item_photo, "media_type": "image" }, ...data.product.image_gallery];
//       setItemMedia(itemMediaFiles);
//       setCurrentImageIndex(0);

//       getCartItems();
//       getStock();
//       fetchReviews(1);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const fetchReviews = async (page = 1) => {
//     if (!productId) return;
//     setLoadingReviews(true);
//     try {
//       const response = await Api.get(`api/review-list/${productId}/?page=${page}&page_size=${pageSize}`);
//       if (response.data) {
//         setReviews(response.data.reviews || []);
//         setCurrentPage(response.data.current_page || 1);
//         setTotalPages(response.data.total_pages || 1);
//         setTotalReviews(response.data.total_reviews || 0);
//       }
//     } catch (error) {
//       console.error("Error fetching reviews:", error);
//     } finally {
//       setLoadingReviews(false);
//     }
//   };

//   const getCartItems = async () => {
//     if (!uid) return;
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   const onPressAddToCart = async (productId) => {
//     if (!product) return;

//     const available = stock[productId] || product.stock || 0;
//     if (available === 0) {
//       toast.error("No stock available");
//       return;
//     }

//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, {
//           product_id: productId,
//           u_id: uid
//         });

//         setCartItems(prev => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1
//         }));

//         if (refreshCart) refreshCart();
//         toast.success("Added to cart successfully!");
//       } catch (error) {
//         console.error("Error adding product to cart:", error);
//         toast.error("Failed to add to cart");
//       }
//     } else {
//       onClose();
//       window.location.href = `/login/?next=${window.location.pathname}`;
//     }
//   };

//   const addOne = async (productId) => {
//     if (!uid) {
//       onClose();
//       window.location.href = `/login/?next=${window.location.pathname}`;
//       return;
//     }

//     const available = stock[productId] || product?.stock || 0;
//     const currentQty = cartItems[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, {
//           product_id: productId,
//           user_id: uid
//         });

//         setCartItems(prev => ({
//           ...prev,
//           [productId]: currentQty + 1
//         }));

//         if (refreshCart) refreshCart();
//         toast.success("Quantity increased");
//       } catch (error) {
//         console.error("Error increasing quantity:", error);
//         toast.error("Failed to increase quantity");
//       }
//     } else {
//       toast.error(`Only ${available} items available in stock.`);
//     }
//   };

//   const subOne = async (productId) => {
//     if (!uid) return;

//     if (cartItems[productId] > 1) {
//       try {
//         await Api.post(`api/decrease/main/`, {
//           product_id: productId,
//           user_id: uid
//         });

//         setCartItems(prev => ({
//           ...prev,
//           [productId]: prev[productId] - 1,
//         }));

//         if (refreshCart) refreshCart();
//         toast.info("Quantity decreased");
//       } catch (error) {
//         console.error("Error decreasing quantity:", error);
//         toast.error("Failed to decrease quantity");
//       }
//     } else {
//       try {
//         await Api.post(`api/remove_from_cart/`, {
//           product_id: productId,
//           user_id: uid
//         });

//         const updatedCartItems = { ...cartItems };
//         delete updatedCartItems[productId];
//         setCartItems(updatedCartItems);

//         if (refreshCart) refreshCart();
//         toast.info("Item removed from cart");
//       } catch (error) {
//         console.error("Error removing from cart:", error);
//         toast.error("Failed to remove from cart");
//       }
//     }
//   };

//   const handleSubmitReview = async () => {
//     if (!uid) {
//       toast.error("Please login to submit a review");
//       onClose();
//       window.location.href = `/login/?next=${window.location.pathname}`;
//       return;
//     }

//     if (rating === 0) {
//       toast.error("Please select a rating");
//       return;
//     }

//     if (comment.trim() === "") {
//       toast.error("Please write a review");
//       return;
//     }

//     setSubmittingReview(true);
//     try {
//       const response = await Api.post(`api/review/${productId}/`, {
//         rating: rating,
//         review_text: comment.trim()
//       });

//       if (response.data) {
//         toast.success("Review submitted successfully!");
//         setComment("");
//         setRating(0);
//         fetchProduct();
//         fetchReviews(1);
//       }
//     } catch (error) {
//       console.error("Error submitting review:", error);
//       toast.error("Failed to submit review");
//     } finally {
//       setSubmittingReview(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       fetchReviews(newPage);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   // Safely check if product is in wishlist
//   const isInWishlist = product ? wishlist.some((w) => w && w.item && w.item.id === product.id) : false;
//   const isInCart = product ? cartItems[product.id] > 0 : false;
//   const availableStock = product?.stock || 0;

//   // Safely get rating values
//   const ratingValue = product?.rating 
//     ? (typeof product.rating === 'object' 
//         ? (product.rating?.average || 0) 
//         : (product.rating || 0))
//     : 0;

//   const productTotalReviews = product?.rating 
//     ? (typeof product.rating === 'object' 
//         ? (product.rating?.total_reviews || 0) 
//         : 0)
//     : 0;

//   const renderPagination = () => {
//     const pages = [];
//     const maxVisiblePages = 5;

//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <button
//           key={i}
//           onClick={() => handlePageChange(i)}
//           style={{
//             padding: '8px 14px',
//             margin: '0 4px',
//             border: `1px solid ${currentPage === i ? '#5dc5fa' : '#ddd'}`,
//             backgroundColor: currentPage === i ? '#5dc5fa' : 'white',
//             color: currentPage === i ? 'white' : '#333',
//             borderRadius: '50px',
//             fontWeight: '600',
//             fontSize: '13px',
//             cursor: 'pointer'
//           }}
//         >
//           {i}
//         </button>
//       );
//     }

//     return (
//       <div className="pagination" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
//         <button
//           onClick={() => handlePageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           style={{
//             padding: '8px 16px',
//             margin: '0 4px',
//             border: '1px solid #ddd',
//             backgroundColor: currentPage === 1 ? '#f5f5f5' : 'white',
//             color: currentPage === 1 ? '#999' : '#333',
//             borderRadius: '50px',
//             fontWeight: '600',
//             fontSize: '13px',
//             cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//           }}
//         >
//           Previous
//         </button>
//         {pages}
//         <button
//           onClick={() => handlePageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           style={{
//             padding: '8px 16px',
//             margin: '0 4px',
//             border: '1px solid #ddd',
//             backgroundColor: currentPage === totalPages ? '#f5f5f5' : 'white',
//             color: currentPage === totalPages ? '#999' : '#333',
//             borderRadius: '50px',
//             fontWeight: '600',
//             fontSize: '13px',
//             cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//           }}
//         >
//           Next
//         </button>
//       </div>
//     );
//   };

//   if (!isOpen) return null;

//   return (
//     <AnimatePresence>
//       <motion.div
//         className="modal-overlay"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         onClick={onClose}
//       >
//         <motion.div
//           className="modal-content1"
//           initial={{ scale: 0.9, y: 50, opacity: 0 }}
//           animate={{ scale: 1, y: 0, opacity: 1 }}
//           exit={{ scale: 0.9, y: 50, opacity: 0 }}
//           transition={{ type: "spring", damping: 25, stiffness: 300 }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <button className="modal-close-btn" onClick={onClose}>
//             <FaTimes size={24} />
//           </button>

//           {loading ? (
//             <div className="modal-loading">
//               <div className="spinner-border text-primary" role="status" />
//               <p className="mt-2 text-muted">Loading product details...</p>
//             </div>
//           ) : error || !product ? (
//             <div className="modal-error">
//               <div className="alert alert-warning">{error || "Product not found."}</div>
//             </div>
//           ) : (
//             <div className="modal-body">
//               <div className="modal-grid">
//                 {/* Left Column - Images */}
//                 <div className="modal-image-section">
//                   <div className="modal-image-viewport">
//                     {itemMedia[currentImageIndex]?.media_type === 'video' ? (
//                       <video
//                         src={itemMedia[currentImageIndex]?.media_path}
//                         controls
//                         className="modal-full-img"
//                       />
//                     ) : (
//                       <img
//                         src={itemMedia[currentImageIndex]?.media_path || product.item_photo || logo}
//                         alt={product.title}
//                         className="modal-full-img"
//                         onError={(e) => { e.target.src = logo; }}
//                       />
//                     )}
                    
//                     {itemMedia.length > 1 && (
//                       <>
//                         <button
//                           className="modal-nav-arrow"
//                           style={{ left: "12px" }}
//                           onClick={() => setCurrentImageIndex((prev) => (prev - 1 + itemMedia.length) % itemMedia.length)}
//                         >
//                           ‹
//                         </button>
//                         <button
//                           className="modal-nav-arrow"
//                           style={{ right: "12px" }}
//                           onClick={() => setCurrentImageIndex((prev) => (prev + 1) % itemMedia.length)}
//                         >
//                           ›
//                         </button>
//                       </>
//                     )}
//                   </div>

//                   {itemMedia.length > 1 && (
//                     <div className="modal-thumb-container">
//                       {itemMedia.map((media, idx) => (
//                         media.media_type === 'video' ? (
//                           <video
//                             key={idx}
//                             src={media.media_path}
//                             className="modal-thumb-item"
//                             style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
//                             onClick={() => setCurrentImageIndex(idx)}
//                           />
//                         ) : (
//                           <img
//                             key={idx}
//                             src={media.media_path || logo}
//                             alt=""
//                             className="modal-thumb-item"
//                             style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
//                             onClick={() => setCurrentImageIndex(idx)}
//                           />
//                         )
//                       ))}
//                     </div>
//                   )}
//                 </div>

//                 {/* Right Column - Product Info */}
//                 <div className="modal-info-section">
//                   {/* Wishlist Icon */}
//                   <div
//                     className="modal-wishlist-btn"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       if (!wishlistLoading) toggleWishlist(product);
//                     }}
//                   >
//                     {isInWishlist ? (
//                       <FaHeart size={22} color="#e53e3e" />
//                     ) : (
//                       <CiHeart size={24} color="#4a5568" strokeWidth={2} />
//                     )}
//                   </div>

//                   <span className="modal-badge-cat">{product.category_name}</span>
//                   <h2 className="modal-info-title">{product.title}</h2>
                  
//                   <div className="modal-meta-row">
//                     <div className="modal-meta-pill" style={{ background: "#fef7f2", color: "#5dc5fa" }}>
//                       <FaStar color="#FFD700" size={14} />
//                       <span>{ratingValue.toFixed(1)}</span>
//                       <span className="text-muted fw-normal">({productTotalReviews})</span>
//                     </div>
//                     <div className="modal-meta-pill">Brand: {product.brand_name}</div>
//                     <div className="modal-meta-pill">Stock: {availableStock}</div>
//                   </div>

//                   <div className="modal-price-tag">
//                     {product.item_old_price && product.item_old_price > product.item_new_price && (
//                       <span style={{ textDecoration: 'line-through', color: '#a0aec0', fontSize: '20px' }}>
//                         ₹{product.item_old_price}
//                       </span>
//                     )}
//                     <span>₹{product.item_new_price}</span>
//                     {product.item_old_price && product.item_old_price > product.item_new_price && (
//                       <span className="modal-discount-badge">
//                         {product.discount_percentage}% OFF
//                       </span>
//                     )}
//                   </div>

//                   <div className="modal-desc-box" dangerouslySetInnerHTML={{ __html: product.description || "No description available." }} />

//                   <div className="modal-action-section">
//                     {availableStock === 0 ? (
//                       <button className="modal-btn-buy" disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>
//                         Out of Stock
//                       </button>
//                     ) : isInCart ? (
//                       <div className="modal-cart-controls">
//                         <div className="modal-qty-controls">
//                           <button className="modal-btn-qty" onClick={() => subOne(product.id)}>-</button>
//                           <span className="modal-qty-number">{cartItems[product.id]}</span>
//                           <button className="modal-btn-qty" onClick={() => addOne(product.id)}>+</button>
//                         </div>
//                         <motion.button 
//                           whileHover={{ scale: 1.03 }} 
//                           whileTap={{ scale: 0.97 }} 
//                           className="modal-btn-goto-cart" 
//                           onClick={() => {
//                             onClose();
//                             window.location.href = "/cart";
//                           }}
//                         >
//                           🛒 Go to Cart
//                         </motion.button>
//                       </div>
//                     ) : (
//                       <motion.button 
//                         whileHover={{ scale: 1.03 }} 
//                         whileTap={{ scale: 0.97 }} 
//                         className="modal-btn-buy" 
//                         onClick={() => onPressAddToCart(product.id)}
//                       >
//                         🛒 Add to Cart
//                       </motion.button>
//                     )}
//                   </div>

//                   {/* Reviews Section */}
//                   <div className="modal-reviews-section">
//                     <h4 className="modal-reviews-title">Customer Reviews ({totalReviews})</h4>

//                     <div className="modal-review-form">
//                       <h5 className="modal-review-form-title">Write a Review</h5>
//                       <div className="modal-rating-stars">
//                         {[...Array(5)].map((star, index) => {
//                           const currentRating = index + 1;
//                           return (
//                             <label key={index} className="modal-star-label">
//                               <input
//                                 type="radio"
//                                 name="rating"
//                                 value={currentRating}
//                                 onClick={() => setRating(currentRating)}
//                                 style={{ display: 'none' }}
//                               />
//                               <FaStar
//                                 size={28}
//                                 color={currentRating <= (hover || rating) ? "#FFD700" : "#cbd5e1"}
//                                 onMouseEnter={() => setHover(currentRating)}
//                                 onMouseLeave={() => setHover(0)}
//                                 style={{ cursor: 'pointer', transition: "color 0.1s ease" }}
//                               />
//                             </label>
//                           );
//                         })}
//                       </div>
//                       <div className="modal-review-textarea">
//                         <textarea
//                           placeholder="Share your experience with this product..."
//                           value={comment}
//                           onChange={(e) => setComment(e.target.value)}
//                           rows={3}
//                         />
//                       </div>
//                       <button
//                         onClick={handleSubmitReview}
//                         disabled={submittingReview}
//                         className="modal-submit-review-btn"
//                       >
//                         {submittingReview ? 'Submitting...' : 'Submit Review'}
//                       </button>
//                     </div>

//                     <div className="modal-reviews-list">
//                       {loadingReviews ? (
//                         <div className="modal-loading-reviews">Loading reviews...</div>
//                       ) : reviews.length > 0 ? (
//                         <>
//                           {reviews.map((review, i) => (
//                             <motion.div
//                               key={review.id || i}
//                               initial={{ opacity: 0, y: 10 }}
//                               animate={{ opacity: 1, y: 0 }}
//                               transition={{ delay: i * 0.05 }}
//                               className="modal-review-item"
//                             >
//                               <div className="modal-review-header">
//                                 <strong>{review.user_name}</strong>
//                                 <span className="modal-review-date">{formatDate(review.created_at)}</span>
//                               </div>
//                               <div className="modal-review-stars">
//                                 {Array(5).fill().map((_, j) => (
//                                   <FaStar key={j} size={14} color={j < review.rating ? "#FFD700" : "#e2e8f0"} />
//                                 ))}
//                                 <span className="modal-review-rating">{review.rating.toFixed(1)}</span>
//                               </div>
//                               <p className="modal-review-text">{review.review_text}</p>
//                             </motion.div>
//                           ))}

//                           {totalPages > 1 && renderPagination()}

//                           <div className="modal-review-footer">
//                             Showing {reviews.length} of {totalReviews} reviews
//                           </div>
//                         </>
//                       ) : (
//                         <div className="modal-no-reviews">
//                           No reviews yet. Be the first to review this product!
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default ProductModal;

import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaStar, FaTimes } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import Api from "../Utills/Api";
import { toast } from "react-toastify";
import axios from "axios";
import logo from "../../Frozenwala.png";
import { useWishlist } from "../../contexts/WishlistContext";
import "./ProductModal.css";

const ProductModal = ({ isOpen, productId, onClose, refreshCart }) => {
  const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartItems, setCartItems] = useState({});
  const [stock, setStock] = useState({});
  const [itemMedia, setItemMedia] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalReviews, setTotalReviews] = useState(0);
  const [loadingReviews, setLoadingReviews] = useState(false);
  const [submittingReview, setSubmittingReview] = useState(false);

  const uid = localStorage.getItem("user_id");
  const pageSize = 5;

  useEffect(() => {
    if (isOpen && productId) {
      fetchProduct();
    }
  }, [isOpen, productId]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Handle escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  const fetchProduct = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `https://backend.frozenwala.com/api/product-detail/?product_id=${productId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch product");
      }
      const data = await response.json();
      setProduct(data.product);

      const itemMediaFiles = [{ "media_path": data.product.item_photo, "media_type": "image" }, ...data.product.image_gallery];
      setItemMedia(itemMediaFiles);
      setCurrentImageIndex(0);

      getCartItems();
      getStock();
      fetchReviews(1);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const fetchReviews = async (page = 1) => {
    if (!productId) return;
    setLoadingReviews(true);
    try {
      const response = await Api.get(`api/review-list/${productId}/?page=${page}&page_size=${pageSize}`);
      if (response.data) {
        setReviews(response.data.reviews || []);
        setCurrentPage(response.data.current_page || 1);
        setTotalPages(response.data.total_pages || 1);
        setTotalReviews(response.data.total_reviews || 0);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoadingReviews(false);
    }
  };

  const getCartItems = async () => {
    if (!uid) return;
    try {
      const response = await Api.get(`api/get_cart/?user_id=${uid}`);
      const map = {};
      response.data.forEach((item) => (map[item.product_id] = item.quantity));
      setCartItems(map);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const getStock = async () => {
    try {
      const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
      const map = {};
      response.data.forEach((item) => (map[item.item_id] = item.openingstock));
      setStock(map);
    } catch (error) {
      console.error("Error getting stock:", error);
    }
  };

  const onPressAddToCart = async (productId) => {
    if (!product) return;

    const available = stock[productId] || product.stock || 0;
    if (available === 0) {
      toast.error("No stock available");
      return;
    }

    if (uid) {
      try {
        await Api.post(`api/add_to_cart/`, {
          product_id: productId,
          u_id: uid
        });

        setCartItems(prev => ({
          ...prev,
          [productId]: (prev[productId] || 0) + 1
        }));

        if (refreshCart) refreshCart();
        toast.success("Added to cart successfully!");
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Failed to add to cart");
      }
    } else {
      onClose();
      window.location.href = `/login/?next=${window.location.pathname}`;
    }
  };

  const addOne = async (productId) => {
    if (!uid) {
      onClose();
      window.location.href = `/login/?next=${window.location.pathname}`;
      return;
    }

    const available = stock[productId] || product?.stock || 0;
    const currentQty = cartItems[productId] || 0;

    if (available > currentQty) {
      try {
        await Api.post(`api/increase/main/`, {
          product_id: productId,
          user_id: uid
        });

        setCartItems(prev => ({
          ...prev,
          [productId]: currentQty + 1
        }));

        if (refreshCart) refreshCart();
        toast.success("Quantity increased");
      } catch (error) {
        console.error("Error increasing quantity:", error);
        toast.error("Failed to increase quantity");
      }
    } else {
      toast.error(`Only ${available} items available in stock.`);
    }
  };

  const subOne = async (productId) => {
    if (!uid) return;

    if (cartItems[productId] > 1) {
      try {
        await Api.post(`api/decrease/main/`, {
          product_id: productId,
          user_id: uid
        });

        setCartItems(prev => ({
          ...prev,
          [productId]: prev[productId] - 1,
        }));

        if (refreshCart) refreshCart();
        toast.info("Quantity decreased");
      } catch (error) {
        console.error("Error decreasing quantity:", error);
        toast.error("Failed to decrease quantity");
      }
    } else {
      try {
        await Api.post(`api/remove_from_cart/`, {
          product_id: productId,
          user_id: uid
        });

        const updatedCartItems = { ...cartItems };
        delete updatedCartItems[productId];
        setCartItems(updatedCartItems);

        if (refreshCart) refreshCart();
        toast.info("Item removed from cart");
      } catch (error) {
        console.error("Error removing from cart:", error);
        toast.error("Failed to remove from cart");
      }
    }
  };

  const handleSubmitReview = async () => {
    if (!uid) {
      toast.error("Please login to submit a review");
      onClose();
      window.location.href = `/login/?next=${window.location.pathname}`;
      return;
    }

    if (rating === 0) {
      toast.error("Please select a rating");
      return;
    }

    if (comment.trim() === "") {
      toast.error("Please write a review");
      return;
    }

    setSubmittingReview(true);
    try {
      const response = await Api.post(`api/review/${productId}/`, {
        rating: rating,
        review_text: comment.trim()
      });

      if (response.data) {
        toast.success("Review submitted successfully!");
        setComment("");
        setRating(0);
        fetchProduct();
        fetchReviews(1);
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      toast.error("Failed to submit review");
    } finally {
      setSubmittingReview(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchReviews(newPage);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Safely check if product is in wishlist
  const isInWishlist = product ? wishlist.some((w) => w && w.item && w.item.id === product.id) : false;
  const isInCart = product ? cartItems[product.id] > 0 : false;
  const availableStock = product?.stock || 0;

  // Safely get rating values
  const ratingValue = product?.rating
    ? (typeof product.rating === 'object'
        ? (product.rating?.average || 0)
        : (product.rating || 0))
    : 0;

  const productTotalReviews = product?.rating
    ? (typeof product.rating === 'object'
        ? (product.rating?.total_reviews || 0)
        : 0)
    : 0;

  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          style={{
            padding: '8px 14px',
            margin: '0 4px',
            border: `1px solid ${currentPage === i ? '#5dc5fa' : '#ddd'}`,
            backgroundColor: currentPage === i ? '#5dc5fa' : 'white',
            color: currentPage === i ? 'white' : '#333',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '13px',
            cursor: 'pointer'
          }}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: '8px 16px',
            margin: '0 4px',
            border: '1px solid #ddd',
            backgroundColor: currentPage === 1 ? '#f5f5f5' : 'white',
            color: currentPage === 1 ? '#999' : '#333',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '13px',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
          }}
        >
          Previous
        </button>
        {pages}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            padding: '8px 16px',
            margin: '0 4px',
            border: '1px solid #ddd',
            backgroundColor: currentPage === totalPages ? '#f5f5f5' : 'white',
            color: currentPage === totalPages ? '#999' : '#333',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '13px',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
          }}
        >
          Next
        </button>
      </div>
    );
  };

  if (!isOpen) return null;

  // Rendered via a portal into document.body so the modal is never a
  // descendant of a parent card that applies a CSS transform on hover
  // (e.g. the Popular Products card). A transformed ancestor becomes the
  // containing block for position:fixed children, which is what was
  // shrinking/clipping this modal down to the card's size.
  return createPortal(
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content1"
          initial={{ scale: 0.9, y: 50, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          exit={{ scale: 0.9, y: 50, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close-btn" onClick={onClose}>
            <FaTimes size={24} />
          </button>

          {loading ? (
            <div className="modal-loading">
              <div className="spinner-border text-primary" role="status" />
              <p className="mt-2 text-muted">Loading product details...</p>
            </div>
          ) : error || !product ? (
            <div className="modal-error">
              <div className="alert alert-warning">{error || "Product not found."}</div>
            </div>
          ) : (
            <div className="modal-body">
              <div className="modal-grid">
                {/* Left Column - Images */}
                <div className="modal-image-section">
                  <div className="modal-image-viewport">
                    {itemMedia[currentImageIndex]?.media_type === 'video' ? (
                      <video
                        src={itemMedia[currentImageIndex]?.media_path}
                        controls
                        className="modal-full-img"
                      />
                    ) : (
                      <img
                        src={itemMedia[currentImageIndex]?.media_path || product.item_photo || logo}
                        alt={product.title}
                        className="modal-full-img"
                        onError={(e) => { e.target.src = logo; }}
                      />
                    )}

                    {itemMedia.length > 1 && (
                      <>
                        <button
                          className="modal-nav-arrow"
                          style={{ left: "12px" }}
                          onClick={() => setCurrentImageIndex((prev) => (prev - 1 + itemMedia.length) % itemMedia.length)}
                        >
                          ‹
                        </button>
                        <button
                          className="modal-nav-arrow"
                          style={{ right: "12px" }}
                          onClick={() => setCurrentImageIndex((prev) => (prev + 1) % itemMedia.length)}
                        >
                          ›
                        </button>
                      </>
                    )}
                  </div>

                  {itemMedia.length > 1 && (
                    <div className="modal-thumb-container">
                      {itemMedia.map((media, idx) => (
                        media.media_type === 'video' ? (
                          <video
                            key={idx}
                            src={media.media_path}
                            className="modal-thumb-item"
                            style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
                            onClick={() => setCurrentImageIndex(idx)}
                          />
                        ) : (
                          <img
                            key={idx}
                            src={media.media_path || logo}
                            alt=""
                            className="modal-thumb-item"
                            style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
                            onClick={() => setCurrentImageIndex(idx)}
                          />
                        )
                      ))}
                    </div>
                  )}
                </div>

                {/* Right Column - Product Info */}
                <div className="modal-info-section">
                  {/* Wishlist Icon */}
                  <div
                    className="modal-wishlist-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!wishlistLoading) toggleWishlist(product);
                    }}
                  >
                    {isInWishlist ? (
                      <FaHeart size={22} color="#e53e3e" />
                    ) : (
                      <CiHeart size={24} color="#4a5568" strokeWidth={2} />
                    )}
                  </div>

                  <span className="modal-badge-cat">{product.category_name}</span>
                  <h2 className="modal-info-title">{product.title}</h2>

                  <div className="modal-meta-row">
                    <div className="modal-meta-pill" style={{ background: "#fef7f2", color: "#5dc5fa" }}>
                      <FaStar color="#FFD700" size={14} />
                      <span>{ratingValue.toFixed(1)}</span>
                      <span className="text-muted fw-normal">({productTotalReviews})</span>
                    </div>
                    <div className="modal-meta-pill">Brand: {product.brand_name}</div>
                    <div className="modal-meta-pill">Stock: {availableStock}</div>
                  </div>

                  <div className="modal-price-tag">
                    {product.item_old_price && product.item_old_price > product.item_new_price && (
                      <span style={{ textDecoration: 'line-through', color: '#a0aec0', fontSize: '20px' }}>
                        ₹{product.item_old_price}
                      </span>
                    )}
                    <span>₹{product.item_new_price}</span>
                    {product.item_old_price && product.item_old_price > product.item_new_price && (
                      <span className="modal-discount-badge">
                        {product.discount_percentage}% OFF
                      </span>
                    )}
                  </div>

                  <div className="modal-desc-box" dangerouslySetInnerHTML={{ __html: product.description || "No description available." }} />

                  <div className="modal-action-section">
                    {availableStock === 0 ? (
                      <button className="modal-btn-buy" disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>
                        Out of Stock
                      </button>
                    ) : isInCart ? (
                      <div className="modal-cart-controls">
                        <div className="modal-qty-controls">
                          <button className="modal-btn-qty" onClick={() => subOne(product.id)}>-</button>
                          <span className="modal-qty-number">{cartItems[product.id]}</span>
                          <button className="modal-btn-qty" onClick={() => addOne(product.id)}>+</button>
                        </div>
                        <motion.button
                          whileHover={{ scale: 1.03 }}
                          whileTap={{ scale: 0.97 }}
                          className="modal-btn-goto-cart"
                          onClick={() => {
                            onClose();
                            window.location.href = "/cart";
                          }}
                        >
                          🛒 Go to Cart
                        </motion.button>
                      </div>
                    ) : (
                      <motion.button
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        className="modal-btn-buy"
                        onClick={() => onPressAddToCart(product.id)}
                      >
                        🛒 Add to Cart
                      </motion.button>
                    )}
                  </div>

                  {/* Reviews Section */}
                  <div className="modal-reviews-section">
                    <h4 className="modal-reviews-title">Customer Reviews ({totalReviews})</h4>

                    <div className="modal-review-form">
                      <h5 className="modal-review-form-title">Write a Review</h5>
                      <div className="modal-rating-stars">
                        {[...Array(5)].map((star, index) => {
                          const currentRating = index + 1;
                          return (
                            <label key={index} className="modal-star-label">
                              <input
                                type="radio"
                                name="rating"
                                value={currentRating}
                                onClick={() => setRating(currentRating)}
                                style={{ display: 'none' }}
                              />
                              <FaStar
                                size={28}
                                color={currentRating <= (hover || rating) ? "#FFD700" : "#cbd5e1"}
                                onMouseEnter={() => setHover(currentRating)}
                                onMouseLeave={() => setHover(0)}
                                style={{ cursor: 'pointer', transition: "color 0.1s ease" }}
                              />
                            </label>
                          );
                        })}
                      </div>
                      <div className="modal-review-textarea">
                        <textarea
                          placeholder="Share your experience with this product..."
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          rows={3}
                        />
                      </div>
                      <button
                        onClick={handleSubmitReview}
                        disabled={submittingReview}
                        className="modal-submit-review-btn"
                      >
                        {submittingReview ? 'Submitting...' : 'Submit Review'}
                      </button>
                    </div>

                    <div className="modal-reviews-list">
                      {loadingReviews ? (
                        <div className="modal-loading-reviews">Loading reviews...</div>
                      ) : reviews.length > 0 ? (
                        <>
                          {reviews.map((review, i) => (
                            <motion.div
                              key={review.id || i}
                              initial={{ opacity: 0, y: 10 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: i * 0.05 }}
                              className="modal-review-item"
                            >
                              <div className="modal-review-header">
                                <strong>{review.user_name}</strong>
                                <span className="modal-review-date">{formatDate(review.created_at)}</span>
                              </div>
                              <div className="modal-review-stars">
                                {Array(5).fill().map((_, j) => (
                                  <FaStar key={j} size={14} color={j < review.rating ? "#FFD700" : "#e2e8f0"} />
                                ))}
                                <span className="modal-review-rating">{review.rating.toFixed(1)}</span>
                              </div>
                              <p className="modal-review-text">{review.review_text}</p>
                            </motion.div>
                          ))}

                          {totalPages > 1 && renderPagination()}

                          <div className="modal-review-footer">
                            Showing {reviews.length} of {totalReviews} reviews
                          </div>
                        </>
                      ) : (
                        <div className="modal-no-reviews">
                          No reviews yet. Be the first to review this product!
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
};

export default ProductModal;